import React, { Component } from 'react';
import Board from './Board/Board';

class App extends Component {
  render() {
    return (
      <Board />
    );
  }
}

export default App;
